module.exports = "../../static/img/darkLogo.b009016.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/darkLogo.png
// module id = 1373
// module chunks = 0